import React from 'react';
import { format, getMonth, subMonths } from 'date-fns';

interface MonthDropdownProps {
  onChange: (month: number) => void;
}

type MonthDropdownObject = {
  title: string;
  value: number;
};

const MonthDropdown: React.FC<MonthDropdownProps> = ({ onChange }) => {
  const currentDate = new Date();

  const months: MonthDropdownObject[] = Array.from({ length: 12 }, (_, i) => {
    const pastMonthDate = subMonths(currentDate, i + 1);

    return {
      title: format(pastMonthDate, 'MMM'),
      value: getMonth(pastMonthDate) + 1,
    };
  });

  return (
    <select onChange={e => onChange(Number(e.target.value))}>
      {months.map((month, index) => (
        <option key={index} value={month.value}>
          {month.title}
        </option>
      ))}
    </select>
  );
};

export default MonthDropdown;
